import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import ConditionalThumbnailPlayer from 'components/StreamPlayer/ConditionalThumbnailPlayer';
import { generateID } from 'utils/helpers';

import styles from './SimilarBroadcasts.css';


const IDS = {
  prefix: 'SmOrU3pm',
  element: 'SimilarBroadcastsDesktop',
  thumbnail: 'thumbnail',
};

const makeId = generateID(IDS.prefix, IDS.element);

const MAX_SIMILAR_CAMS = 12;

const SimilarBroadcastsDesktop = (props) => {
  const { similarCams, accessLevel, isAdmin, genderPreference, approvedAccounts } = props;
  const cams = similarCams.slice(0, MAX_SIMILAR_CAMS);

  return (
    <div className={styles.similarWrapDesktop}>
      <Grid container={true}>
        {cams.map((user, index) => (
          <Grid key={user.userId} item={true} md={2} sm={2} xs={2}>
            <div className={styles.item} id={`${makeId(IDS.thumbnail)}_${index + 1}`}>
              <ConditionalThumbnailPlayer
                accessLevel={accessLevel}
                approvedAccounts={approvedAccounts}
                genderPreference={genderPreference}
                isAdmin={isAdmin}
                showFlags={false}
                user={user}
              />
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

SimilarBroadcastsDesktop.propTypes = {
  accessLevel: PropTypes.number.isRequired,
  approvedAccounts: PropTypes.object.isRequired,
  genderPreference: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  similarCams: PropTypes.array.isRequired,
};

export default SimilarBroadcastsDesktop;
